<template>
  <v-card flat class="bg-primary px-4 pb-8">
    <div
      class="d-flex px-2 pb-2"
      style="gap: 10px"
      v-if="selected_accounts.length > 0"
    >
      <v-btn
        icon
        size="large"
        variant="text"
        @click="type = 'facebook'"
        v-if="selected_accounts.find((a) => a.type === 'facebook') != undefined"
      >
        <v-icon :color="type === 'facebook' ? 'buttonGreen' : 'white'"
          >mdi-facebook</v-icon
        >
      </v-btn>
      <v-btn
        v-if="selected_accounts.find((a) => a.type === 'linkedin') != undefined"
        icon
        @click="type = 'linkedin'"
        variant="text"
        size="large"
      >
        <v-icon :color="type === 'linkedin' ? 'buttonGreen' : 'white'"
          >mdi-linkedin</v-icon
        >
      </v-btn>

      <v-btn
        icon
        @click="type = 'instagram'"
        size="large"
        variant="text"
        v-if="
          selected_accounts.find((a) => a.type === 'instagram') != undefined
        "
      >
        <v-icon :color="type === 'instagram' ? 'buttonGreen' : 'white'"
          >mdi-instagram</v-icon
        >
      </v-btn>
      <v-spacer></v-spacer>
    </div>
    <!-- <Facebook
      v-if="type === 'facebook'"
      :account="facebook_account"
      :message="message"
      :comment="comment"
      :media="media"
      :preview="preview"
      @alt="$emit('alt')"
      :id="id"
      :open_link="false"
    />
    <Instagram
      :account="channels.find((a) => a.type === 'instagram')"
      :post="instaPost"
      :comment="comment"
      v-else-if="type === 'instagram'"
      :open_link="false"
    /> -->
    <Linkedin
      v-if="type === 'linkedin'"
      :post="{
        variation: variation ? variation : variations[0],
        media: media,
      }"
      :readMoreEnabled="readMoreEnabled"
      :a="selected_accounts.find((a) => a.type === 'linkedin')"
    />
  </v-card>
</template>

<script>
// import Facebook from "@/components/preview/PreviewFacebook.vue";
// import Instagram from "./instagramPreview.vue";
import Linkedin from "./PreviewLinkedin.vue";

import { mapState } from "vuex";

export default {
  components: {
    // Facebook,
    // Instagram,
    Linkedin,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    channels: {
      type: Array,
      default() {
        return [];
      },
    },
    variations: {
      type: Array,
      default() {
        return [];
      },
    },
    variation: {
      type: Object,
      default() {
        return null;
      },
    },
    selected_accounts: {
      type: Array,
      default() {
        return [];
      },
    },
    readMoreEnabled: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
    },
    media: {
      type: Array,
    },
    preview: {
      type: Object,
      default: null,
    },
    comment: String,
    comments: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  mounted() {
    if (this.selected_accounts.length > 0) {
      this.type = this.selected_accounts[0].type;
    }
  },
  watch: {
    selected_accounts: {
      deep: true,
      async handler() {
        if (
          this.selected_accounts.length > 0 &&
          this.selected_accounts.find((a) => a.type === this.type) === undefined
        ) {
          this.type = this.selected_accounts[0].type;
        }
      },
    },
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
      accounts: (state) => state.accounts.accounts,
    }),
    facebook_account() {
      let a =
        this.selected_accounts.length === 0 ||
        this.selected_accounts.find((a) => a.type === "facebook") === undefined
          ? null
          : this.selected_accounts.find((a) => a.type === "facebook");
      return !a ? null : a;
    },
    instaPost() {
      let post = {
        timestamp: Math.floor(Date.now() / 1000),
        media: this.media,
        like_count: 34,
        caption: this.message,
      };

      return post;
    },
  },
  data() {
    return {
      type: "linkedin",
    };
  },
};
</script>
